import { useQuery } from '@tanstack/react-query'
import { useFeatureFlags } from '@node-space/hooks'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWalletProfilesV1, getWalletProfilesV2 } from 'services/CustomerService'
import { GetCustomerWalletProfilesRequest } from 'types/customers'

export const useGetCustomersWalletProfileQuery = (request?: GetCustomerWalletProfilesRequest) => {
  const { enableWalletCreationV2 } = useFeatureFlags()

  return useQuery({
    queryKey: reactQueryKeys.customerWalletProfiles(request),
    queryFn: () => {
      if (enableWalletCreationV2) {
        return getWalletProfilesV2(request)
      }
      const { customerId, ...v1Request } = request || {}
      return getWalletProfilesV1(v1Request)
    },
  })
}
